import * as model from './model';
import * as actions from './actions';

export const staticPages = {
  ...model,
  ...actions,
};
